// @ts-nocheck
function activateOptimize(customEvent?: string) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: customEvent || 'optimize.activate' });
}

export default activateOptimize;
